interface GearWithSchemeAndThreeObjectsSVGProps {
  color: string;
  style: React.CSSProperties;
}

const GearWithSchemeAndThreeObjectsSVG = ({
  color,
  style,
}: GearWithSchemeAndThreeObjectsSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="58"
    height="48"
    viewBox="0 0 58 48"
    fill="none"
  >
    <g clipPath="url(#clip0_1655_19612)">
      <path
        d="M7.56445 28.4047V14.4931C7.56445 14.0264 7.9406 13.6475 8.41007 13.6475H18.6875"
        stroke={color}
        strokeWidth="1.42748"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.5879 13.6504H48.3292C48.7958 13.6504 49.1748 14.0294 49.1748 14.496V27.1236"
        stroke={color}
        strokeWidth="1.42748"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.1406 31.0062V25.7656"
        stroke={color}
        strokeWidth="1.42748"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.2355 36.5092C35.4533 37.2219 35.5692 37.9798 35.5692 38.7661C35.5692 43.0563 32.0935 46.5321 27.8032 46.5321C23.5129 46.5321 20.0371 43.0563 20.0371 38.7661C20.0371 34.4758 23.5129 31 27.8032 31C30.1788 31 32.3056 32.0662 33.7309 33.7489"
        stroke={color}
        strokeWidth="1.42748"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.2899 42.352C31.2712 41.5313 32.212 39.2599 31.3913 37.2786C30.5707 35.2973 28.2992 34.3564 26.3179 35.1771C24.3366 35.9978 23.3958 38.2692 24.2164 40.2505C25.0371 42.2318 27.3086 43.1727 29.2899 42.352Z"
        stroke={color}
        strokeWidth="1.42748"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.8027 38.7663L32.7661 36.0654"
        stroke={color}
        strokeWidth="1.42748"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.4812 36.9195L32.7617 36.0625L32.9795 34.1564L36.97 31.9844L36.9954 33.7604L38.4746 34.7475L34.4812 36.9195Z"
        stroke={color}
        strokeWidth="1.42748"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.1989 42.8568C55.4291 41.2787 56.1729 39.2142 56.1729 36.9545C56.1729 34.1603 55.036 31.6659 53.2486 30.0171C52.2899 29.1319 51.0964 28.6172 49.8577 28.4673L49.7587 28.1251C49.391 26.8694 48.0788 26.151 46.8231 26.5158L47.4425 28.6369C46.8938 28.784 46.3593 28.9989 45.853 29.2902L44.8519 29.8728C44.3683 30.1528 44.2042 30.7722 44.4814 31.2586L44.7699 31.762L42.3546 33.1563C41.8682 33.4363 41.7042 34.0557 41.9842 34.5421L42.8241 35.9958C43.0645 36.4143 43.5113 36.6717 43.995 36.6717H45.4232C45.9775 36.6717 46.43 36.2248 46.43 35.6677L49.7361 34.6354C49.6823 35.3142 49.4702 36.1259 48.8876 36.8781C48.5652 37.2967 48.141 37.6276 47.6828 37.8963C46.8288 38.394 44.801 39.8844 44.801 42.8568"
        stroke={color}
        strokeWidth="1.42748"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.39 42.9727H54.7042C55.8241 42.9727 56.732 43.8805 56.732 45.0004V45.8065C56.732 46.1798 56.4294 46.4824 56.056 46.4824H43.0353C42.662 46.4824 42.3594 46.1798 42.3594 45.8065V45.0004C42.3594 43.8805 43.2672 42.9727 44.3871 42.9727H44.39Z"
        stroke={color}
        strokeWidth="1.42748"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4715 28.7676H1.91188C1.38669 28.7676 0.960938 29.2043 0.960938 29.743V45.0998C0.960938 45.6386 1.38669 46.0753 1.91188 46.0753H13.4715C13.9967 46.0753 14.4225 45.6386 14.4225 45.0998V29.743C14.4225 29.2043 13.9967 28.7676 13.4715 28.7676Z"
        stroke={color}
        strokeWidth="1.42748"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9886 34.1221C11.5445 33.6781 10.8262 33.6781 10.385 34.1221L6.10321 38.4039L4.78813 37.0888C4.34411 36.6448 3.62576 36.6448 3.18458 37.0888C2.74056 37.5328 2.74056 38.2512 3.18458 38.6923L5.20386 40.7116C5.44991 40.9577 5.7808 41.0623 6.10321 41.034C6.42562 41.0623 6.75651 40.9577 7.00256 40.7116L11.9886 35.7256C12.4326 35.2816 12.4326 34.5633 11.9886 34.1221Z"
        stroke={color}
        strokeWidth="1.42748"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.5852 13.5274C37.5852 12.9335 37.5229 12.3537 37.4183 11.7909L39.8024 9.85929C39.5394 9.02216 39.1887 8.202 38.7306 7.41013C38.2724 6.61825 37.7379 5.90556 37.144 5.25791L34.2762 6.35806C33.3995 5.60578 32.3814 5.01469 31.2671 4.62158L30.7863 1.58699C29.9294 1.39751 29.0442 1.29004 28.1307 1.29004C27.2172 1.29004 26.3292 1.39751 25.4751 1.58699L24.9943 4.62158C23.8828 5.01469 22.8647 5.60295 21.9852 6.35806L19.1174 5.25791C18.5264 5.90556 17.989 6.61825 17.5308 7.41013C17.0755 8.202 16.7248 9.02216 16.459 9.85929L18.8431 11.7909C18.7385 12.3537 18.6762 12.9335 18.6762 13.5274C18.6762 14.1213 18.7385 14.7011 18.8431 15.2639L16.459 17.1955C16.722 18.0326 17.0727 18.8528 17.5308 19.6446C17.9862 20.4365 18.5235 21.1492 19.1174 21.7969L21.9852 20.6967C22.8619 21.449 23.88 22.0401 24.9943 22.4332L25.4751 25.4678C26.332 25.6573 27.2172 25.7647 28.1307 25.7647C29.0442 25.7647 29.9322 25.6573 30.7863 25.4678L31.2671 22.4332C32.3786 22.0401 33.3967 21.4518 34.2762 20.6967L37.144 21.7969C37.7351 21.1492 38.2724 20.4365 38.7306 19.6446C39.1859 18.8528 39.5366 18.0326 39.8024 17.1955L37.4183 15.2639C37.5229 14.7011 37.5852 14.1213 37.5852 13.5274Z"
        stroke={color}
        strokeWidth="1.42748"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.7809 17.1789C33.7965 15.1633 33.7965 11.8953 31.7809 9.87967C29.7653 7.86404 26.4973 7.86404 24.4817 9.87967C22.466 11.8953 22.466 15.1633 24.4817 17.1789C26.4973 19.1946 29.7653 19.1946 31.7809 17.1789Z"
        stroke={color}
        strokeWidth="1.42748"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1655_19612">
        <rect
          width="57.7191"
          height="46.5204"
          fill={color}
          transform="translate(0 0.883789)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default GearWithSchemeAndThreeObjectsSVG;
